var themeOptions = function (theme) { return ({
    components: {
        MuiTypography: {
            defaultProps: {
                // This is intentionally different than the default variant set in in the component. This is for mui's uses in slots (e.g. form control label), the one in component is for direct Typography uses by our users.
                variant: 'uiTextSmall',
                variantMapping: {
                    heading1: 'h1',
                    heading2: 'h2',
                    heading3: 'h3',
                    heading4: 'h4',
                    heading5: 'h5',
                    heading6: 'h6',
                    headingXLarge: 'div',
                    headingLarge: 'div',
                    headingMedium: 'div',
                    paragraphDefault: 'p',
                    paragraphSmall: 'p',
                    paragraphTiny: 'p',
                    uiTextDefault: 'span',
                    uiTextSmall: 'span',
                    uiTextTiny: 'span',
                },
            },
            styleOverrides: {
                root: {
                    fontFamily: theme.typography.fontFamily,
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=typographyTheme.js.map